export default "__VITE_ASSET__b48c412a__$_?component__"